import { useLocation, useNavigate } from 'react-router-dom'

export default function FloatingBookNow(){
  const navigate = useNavigate()
  const location = useLocation()

  if (location.pathname === "/packages") return <></>

  function click(){
    navigate("/packages#booking")
  }

  return <div className='floating-book-now' onClick={click}>
    BOOK NOW
  </div>
}